import cx from 'clsx';
import React, { FunctionComponent } from 'react';
import styles from './DisqusComments.module.scss';
import { Block, BlockContent, EmbedComments } from 'components/elements';
import { LazyComponent } from 'utils/lazy';
import { WPAcfBasic } from 'types/acf';
import { WPSimpleArticle } from 'types/articles';
import { useLocation } from 'react-router';
import { getArticleTerms } from 'utils';

interface OwnProps {
  article: WPSimpleArticle<WPAcfBasic>;
  disable?: boolean;
}

type DisqusCommentsProps = Omit<JSX.IntrinsicElements['div'], 'children'> & OwnProps;

const DisqusComments: FunctionComponent<DisqusCommentsProps> = props => {
  const { className, article, disable, ...rest } = props;
  const { title, _embedded, slug } = article;
  const terms = getArticleTerms(_embedded);
  const { category: categories = [] } = terms;
  const location = useLocation();

  const contactFormClassNames = cx({
    [styles.wrapper]: true,
    ...(className && { [className]: true }),
  });

  if (disable) {
    return null;
  }

  return (
    <Block id="disqus-comments" data-module="disqus-comments">
      <BlockContent>
        <LazyComponent>
          <div id="comments" className={contactFormClassNames} {...rest}>
            <EmbedComments
              url={process.env.NODE_ENV === 'development' ? `${process.env.REACT_APP_WEBSITE_URI}${location.pathname}` : window.location.href}
              identifier={`#${slug}`}
              title={title.rendered}
              {...(categories && categories[0] && { categoryID: categories[0].id })}
            />
          </div>
        </LazyComponent>
      </BlockContent>
    </Block>
  );
};

export default DisqusComments;
